import { mapState, mapActions } from 'vuex'
import { isString } from 'lodash/lang'
import { BaseForm } from '@argon/app/components'
import { required } from 'vuelidate/lib/validators'
import { NAMESPACE } from '../store'
import { NAMESPACE as BOARD_NAMESPACE } from '@argon/evo/boards/store'
import { NAMESPACE as ADDON_NAMESPACE } from '../../addons/store'

export default {
  name: 'NewEntityMixin',
  extends: BaseForm,
  props: {
    dismiss: { type: Function, required: true }
  },
  validations: {
    form: {
      display: { required },
      description: {}
    }
  },
  data: () => ({
    form: {
      display: '',
      description: ''
    },
    tags: [],
    counts: 'comments,documents,reminders,tags,todos,tasks',
    include: 'users',
    submitting: false
  }),
  computed: {
    ...mapState(BOARD_NAMESPACE, ['board', 'title', 'entityType', 'collectionURL', 'startingStates', 'stateAttr']),
    ...mapState(ADDON_NAMESPACE, ['labels']),
    nameErrors() {
      const errors = []
      if (!this.$v.form.display.$dirty) return errors
      !this.$v.form.display.required && errors.push(this.$t('required'))
      this.getServerErrors('display', errors)
      return errors
    }
  },
  methods: {
    ...mapActions(NAMESPACE, ['listBoardItems', 'createAndAdd']),
    ...mapActions(ADDON_NAMESPACE, ['createLabel', 'createEntityAddon']),
    updateTags(value) {
      this.tags = []
      return new Promise((resolve, reject) => {
        value.forEach((element) => {
          if (isString(element)) {
            this.createLabel({ data: { text: element } }).then((result) => {
              this.tags.push(result)
            })
          } else {
            this.tags.push(element)
          }
        })
        resolve(true)
      })
    },
    buildPayload() {
      return {
        counts: this.counts,
        include: this.include,
        flowState: this.startingStates[0],
        url: this.collectionURL,
        data: this.form,
        stateAttr: this.stateAttr,
        boardRef: this.board.refname,
        addons: this.tags.map((x) => ({ name: 'tags', data: { label_id: x.id } }))
      }
    },
    doSubmit() {
      if (this.$v.form.$invalid) {
        return this.$v.form.$touch()
      }
      let payload = this.buildPayload()
      this.submitting = true
      this.createAndAdd(payload)
        .then(() => {
          this.dismiss()
        })
        .catch(this.setServerErrors)
        .finally(() => {
          this.submitting = false
        })
    }
  }
}
